import { combineReducers } from 'redux';

const errorMessage = (state = null, action) => {
  switch (action.type) {
    case 'LOGIN_REJECTED':
      return action.payload.message;
    default:
      return state;
  }
};

const portalUsers = (state = [], action) => {
  switch (action.type) {
    case 'FETCH_USERS_FULFILLED':
      return action.payload.data;
    case 'FETCH_USERS_REJECTED':
      return [];
    default:
      return state;
  }
};

const vendorUsers = (state = [], action) => {
  switch (action.type) {
    case 'FETCH_CHILDREN_FULFILLED':
      return action.payload.data;
    case 'FETCH_CHILDREN_REJECTED':
      return [];
    default:
      return state;
  }
};

const vendorsLoaded = (state = false, action) => {
  switch (action.type) {
    case 'FETCH_CHILDREN_FULFILLED':
      return true;
    case 'FETCH_CHILDREN_PENDING':
      return false;
    default:
      return state;
  }
};

const nonThirdPartyUsers = (state = [], action) => {
  switch (action.type) {
    case 'FETCH_NON_THIRD_PARTY_FULFILLED':
      return action.payload.data.result.filter(
        users => users.role !== 'THIRD_PARTY'
      );
    case 'FETCH_NON_THIRD_PARTY_REJECTED':
      return [];
    default:
      return state;
  }
};

const sponsorsLoaded = (state = false, action) => {
  switch (action.type) {
    case 'FETCH_SPONSORS_FULFILLED':
    case 'FETCH_SPONSORS_REJECTED':
      return true;
    case 'FETCH_SPONSORS_PENDING':
      return false;
    default:
      return state;
  }
};
const isUsersFetching = (state = false, action) => {
  switch (action.type) {
    case 'FETCH_USERS_PENDING':
    case 'FETCH_CHILDREN_PENDING':
      return true;
    case 'FETCH_USERS_REJECTED':
    case 'FETCH_USERS_FULFILLED':
    case 'FETCH_CHILDREN_REJECTED':
    case 'FETCH_CHILDREN_FULFILLED':
      return false;
    default:
      return state;
  }
};

const errorMessageUsers = (state = null, action) => {
  switch (action.type) {
    case 'FETCH_USERS_PENDING':
    case 'FETCH_USERS_FULFILLED':
    case 'FETCH_CHILDREN_PENDING':
      return null;
    case 'FETCH_USERS_REJECTED':
    case 'FETCH_CHILDREN_REJECTED':
      return action.payload.message;
    default:
      return state;
  }
};

const portalUsersLoaded = (state = false, action) => {
  switch (action.type) {
    case 'FETCH_USERS_FULFILLED':
      return true;
    case 'FETCH_USERS_PENDING':
      return false;
    default:
      return state;
  }
};

const users = combineReducers({
  portalUsers,
  vendorUsers,
  vendorsLoaded,
  nonThirdPartyUsers,
  sponsorsLoaded,
  errorMessage,
  isUsersFetching,
  errorMessageUsers,
  portalUsersLoaded,
});

export default users;
